// flatPracticeAreaDict.js

export const flatPracticeAreaDict = {
  "criminal-law": "Criminal Law",
  "white-collar-crime": "White Collar Crime",
  "drug-offenses": "Drug Offenses",
  "dui-dwi": "DUI/DWI",
  "violent-crimes": "Violent Crimes",
  "juvenile-delinquency": "Juvenile Delinquency",
  "federal-crimes": "Federal Crimes",
  "sex-crimes": "Sex Crimes",
  "corporate-law": "Corporate Law",
  "mergers-acquisitions": "Mergers & Acquisitions",
  "corporate-governance": "Corporate Governance",
  "securities-law": "Securities Law",
  "commercial-contracts": "Commercial Contracts",
  "regulatory-compliance": "Regulatory Compliance",
  "corporate-litigation": "Corporate Litigation",
  "family-law": "Family Law",
  divorce: "Divorce",
  "child-custody-visitation": "Child Custody & Visitation",
  "child-support": "Child Support",
  adoption: "Adoption",
  "prenuptial-postnuptial": "Prenuptial & Postnuptial Agreements",
  "domestic-violence": "Domestic Violence",
  "guardianship-conservatorship": "Guardianship & Conservatorship",
  "intellectual-property-law": "Intellectual Property Law",
  "copyright-law": "Copyright Law",
  "trademark-law": "Trademark Law",
  "patent-law": "Patent Law",
  "trade-secrets": "Trade Secrets",
  "licensing-agreements": "Licensing Agreements",
  "ip-litigation": "IP Litigation",
  "tax-law": "Tax Law",
  "corporate-tax": "Corporate Tax",
  "personal-income-tax": "Personal Income Tax",
  "international-tax": "International Tax",
  "estate-gift-tax": "Estate & Gift Tax",
  "tax-planning-compliance": "Tax Planning & Compliance",
  "tax-litigation": "Tax Litigation",
  "environmental-law": "Environmental Law",
  "pollution-control-air-quality": "Pollution Control & Air Quality",
  "hazardous-waste-management": "Hazardous Waste Management",
  "environmental-impact-assessments": "Environmental Impact Assessments",
  "land-use-zoning": "Land Use & Zoning",
  "natural-resource-energy-law": "Natural Resource & Energy Law",
  "climate-change-regulation": "Climate Change Regulation",
  "labor-law": "Labor Law",
  "employment-discrimination": "Employment Discrimination",
  "wage-hour-disputes": "Wage and Hour Disputes",
  "workers-compensation": "Workers’ Compensation",
  "labor-union-relations": "Labor Union Relations",
  "occupational-safety-health": "Occupational Safety & Health",
  "employee-benefits": "Employee Benefits",
  "real-estate-law": "Real Estate Law",
  "residential-transactions": "Residential Transactions",
  "commercial-transactions": "Commercial Transactions",
  "landlord-tenant-disputes": "Landlord-Tenant Disputes",
  "zoning-land-use": "Zoning & Land Use",
  "property-development-planning": "Property Development & Planning",
  "title-escrow-foreclosure": "Title, Escrow & Foreclosure",
  "immigration-law": "Immigration Law",
  "family-based-immigration": "Family-Based Immigration",
  "employment-based-immigration": "Employment-Based Immigration",
  "deportation-removal-defense": "Deportation & Removal Defense",
  "asylum-refugee-law": "Asylum & Refugee Law",
  "naturalization-citizenship": "Naturalization & Citizenship",
  "visa-applications-appeals": "Visa Applications & Appeals",
  "bankruptcy-law": "Bankruptcy Law",
  "chapter-7-liquidation": "Chapter 7 Liquidation",
  "chapter-11-reorganization": "Chapter 11 Reorganization",
  "chapter-13-consumer-bankruptcy": "Chapter 13 Consumer Bankruptcy",
  "bankruptcy-litigation": "Bankruptcy Litigation",
  "corporate-vs-consumer-bankruptcy": "Corporate vs. Consumer Bankruptcy",
  "entertainment-law": "Entertainment Law",
  "media-production-contracts": "Media & Production Contracts",
  "music-film-law": "Music & Film Law",
  "talent-representation": "Talent Representation",
  "ip-entertainment": "Intellectual Property in Entertainment",
  "licensing-distribution": "Licensing & Distribution",
  "digital-rights-management": "Digital Rights Management",
  "personal-injury-law": "Personal Injury Law",
  "motor-vehicle-accidents": "Motor Vehicle Accidents",
  "slip-and-fall": "Slip and Fall",
  "product-liability": "Product Liability",
  "workplace-accidents": "Workplace Accidents",
  "premises-liability": "Premises Liability",
  "catastrophic-brain-injuries": "Catastrophic & Brain Injuries",
  "medical-malpractice-law": "Medical Malpractice Law",
  "misdiagnosis-delayed-diagnosis": "Misdiagnosis & Delayed Diagnosis",
  "surgical-errors": "Surgical Errors",
  "birth-injuries": "Birth Injuries",
  "medication-errors": "Medication Errors",
  "nursing-home-negligence": "Nursing Home Negligence",
  "informed-consent-issues": "Informed Consent Issues",
  "constitutional-law": "Constitutional Law",
  "free-speech-expression": "Free Speech & Expression",
  "due-process-equal-protection": "Due Process & Equal Protection",
  "religious-freedom": "Religious Freedom",
  "privacy-rights": "Privacy Rights",
  "voting-rights": "Voting Rights",
  "separation-of-powers": "Separation of Powers",
  "human-rights-law": "Human Rights Law",
  "civil-rights": "Civil Rights",
  "anti-discrimination-law": "Anti-Discrimination Law",
  "refugee-asylum-rights": "Refugee & Asylum Rights",
  "indigenous-rights": "Indigenous Rights",
  "prisoner-rights": "Prisoner Rights",
  "international-human-rights-treaties": "International Human Rights Treaties",
  "trust-estate-law": "Trust and Estate Law",
  "wills-trusts": "Wills & Trusts",
  "estate-planning-administration": "Estate Planning & Administration",
  "probate-litigation": "Probate Litigation",
  "inheritance-disputes": "Inheritance Disputes",
  "asset-protection": "Asset Protection",
  "charitable-trusts": "Charitable Trusts",
  "international-law": "International Law",
  "international-trade-law": "International Trade Law",
  "diplomatic-consular-law": "Diplomatic & Consular Law",
  "international-arbitration": "International Arbitration",
  "humanitarian-law": "Humanitarian Law",
  "international-criminal-law": "International Criminal Law",
  "treaty-convention-law": "Treaty & Convention Law",
  "antitrust-law": "Antitrust Law",
  "merger-review-regulation": "Merger Review & Regulation",
  "price-fixing-collusion": "Price Fixing & Collusion",
  "monopolistic-practices": "Monopolistic Practices",
  "cartel-activities": "Cartel Activities",
  "market-allocation-schemes": "Market Allocation Schemes",
  "abuse-dominance": "Abuse of Dominance",
  "admiralty-law": "Admiralty Law",
  "maritime-commerce": "Maritime Commerce",
  "shipping-cargo-disputes": "Shipping & Cargo Disputes",
  "marine-insurance": "Marine Insurance",
  "salvage-towage-rights": "Salvage & Towage Rights",
  "cargo-claims": "Cargo Claims",
  "piracy-maritime-security": "Piracy & Maritime Security",
  "health-law": "Health Law",
  "healthcare-regulation-compliance": "Healthcare Regulation & Compliance",
  "hospital-patient-rights": "Hospital & Patient Rights",
  "health-insurance-law": "Health Insurance Law",
  "public-health-law": "Public Health Law",
  "bioethics-medical-research-law": "Bioethics & Medical Research Law",
  "fda-drug-regulation": "FDA & Drug Regulation",
};

export const practiceAreasHierarchy = [
  {
    label: "Criminal Law",
    value: "criminal-law",
    children: [
      { label: "White Collar Crime", value: "white-collar-crime" },
      { label: "Drug Offenses", value: "drug-offenses" },
      { label: "DUI/DWI", value: "dui-dwi" },
      { label: "Violent Crimes", value: "violent-crimes" },
      { label: "Juvenile Delinquency", value: "juvenile-delinquency" },
      { label: "Federal Crimes", value: "federal-crimes" },
      { label: "Sex Crimes", value: "sex-crimes" },
    ],
  },
  {
    label: "Corporate Law",
    value: "corporate-law",
    children: [
      { label: "Mergers & Acquisitions", value: "mergers-acquisitions" },
      { label: "Corporate Governance", value: "corporate-governance" },
      { label: "Securities Law", value: "securities-law" },
      { label: "Commercial Contracts", value: "commercial-contracts" },
      { label: "Regulatory Compliance", value: "regulatory-compliance" },
      { label: "Corporate Litigation", value: "corporate-litigation" },
    ],
  },
  {
    label: "Family Law",
    value: "family-law",
    children: [
      { label: "Divorce", value: "divorce" },
      {
        label: "Child Custody & Visitation",
        value: "child-custody-visitation",
      },
      { label: "Child Support", value: "child-support" },
      { label: "Adoption", value: "adoption" },
      {
        label: "Prenuptial & Postnuptial Agreements",
        value: "prenuptial-postnuptial",
      },
      { label: "Domestic Violence", value: "domestic-violence" },
      {
        label: "Guardianship & Conservatorship",
        value: "guardianship-conservatorship",
      },
    ],
  },
  {
    label: "Intellectual Property Law",
    value: "intellectual-property-law",
    children: [
      { label: "Copyright Law", value: "copyright-law" },
      { label: "Trademark Law", value: "trademark-law" },
      { label: "Patent Law", value: "patent-law" },
      { label: "Trade Secrets", value: "trade-secrets" },
      { label: "Licensing Agreements", value: "licensing-agreements" },
      { label: "IP Litigation", value: "ip-litigation" },
    ],
  },
  {
    label: "Tax Law",
    value: "tax-law",
    children: [
      { label: "Corporate Tax", value: "corporate-tax" },
      { label: "Personal Income Tax", value: "personal-income-tax" },
      { label: "International Tax", value: "international-tax" },
      { label: "Estate & Gift Tax", value: "estate-gift-tax" },
      {
        label: "Tax Planning & Compliance",
        value: "tax-planning-compliance",
      },
      { label: "Tax Litigation", value: "tax-litigation" },
    ],
  },
  {
    label: "Environmental Law",
    value: "environmental-law",
    children: [
      {
        label: "Pollution Control & Air Quality",
        value: "pollution-control-air-quality",
      },
      {
        label: "Hazardous Waste Management",
        value: "hazardous-waste-management",
      },
      {
        label: "Environmental Impact Assessments",
        value: "environmental-impact-assessments",
      },
      { label: "Land Use & Zoning", value: "land-use-zoning" },
      {
        label: "Natural Resource & Energy Law",
        value: "natural-resource-energy-law",
      },
      {
        label: "Climate Change Regulation",
        value: "climate-change-regulation",
      },
    ],
  },
  {
    label: "Labor Law",
    value: "labor-law",
    children: [
      {
        label: "Employment Discrimination",
        value: "employment-discrimination",
      },
      { label: "Wage and Hour Disputes", value: "wage-hour-disputes" },
      { label: "Workers’ Compensation", value: "workers-compensation" },
      { label: "Labor Union Relations", value: "labor-union-relations" },
      {
        label: "Occupational Safety & Health",
        value: "occupational-safety-health",
      },
      { label: "Employee Benefits", value: "employee-benefits" },
    ],
  },
  {
    label: "Real Estate Law",
    value: "real-estate-law",
    children: [
      {
        label: "Residential Transactions",
        value: "residential-transactions",
      },
      { label: "Commercial Transactions", value: "commercial-transactions" },
      {
        label: "Landlord-Tenant Disputes",
        value: "landlord-tenant-disputes",
      },
      { label: "Zoning & Land Use", value: "zoning-land-use" },
      {
        label: "Property Development & Planning",
        value: "property-development-planning",
      },
      {
        label: "Title, Escrow & Foreclosure",
        value: "title-escrow-foreclosure",
      },
    ],
  },
  {
    label: "Immigration Law",
    value: "immigration-law",
    children: [
      {
        label: "Family-Based Immigration",
        value: "family-based-immigration",
      },
      {
        label: "Employment-Based Immigration",
        value: "employment-based-immigration",
      },
      {
        label: "Deportation & Removal Defense",
        value: "deportation-removal-defense",
      },
      { label: "Asylum & Refugee Law", value: "asylum-refugee-law" },
      {
        label: "Naturalization & Citizenship",
        value: "naturalization-citizenship",
      },
      {
        label: "Visa Applications & Appeals",
        value: "visa-applications-appeals",
      },
    ],
  },
  {
    label: "Bankruptcy Law",
    value: "bankruptcy-law",
    children: [
      { label: "Chapter 7 Liquidation", value: "chapter-7-liquidation" },
      {
        label: "Chapter 11 Reorganization",
        value: "chapter-11-reorganization",
      },
      {
        label: "Chapter 13 Consumer Bankruptcy",
        value: "chapter-13-consumer-bankruptcy",
      },
      { label: "Bankruptcy Litigation", value: "bankruptcy-litigation" },
      {
        label: "Corporate vs. Consumer Bankruptcy",
        value: "corporate-vs-consumer-bankruptcy",
      },
    ],
  },
  {
    label: "Entertainment Law",
    value: "entertainment-law",
    children: [
      {
        label: "Media & Production Contracts",
        value: "media-production-contracts",
      },
      { label: "Music & Film Law", value: "music-film-law" },
      { label: "Talent Representation", value: "talent-representation" },
      {
        label: "Intellectual Property in Entertainment",
        value: "ip-entertainment",
      },
      { label: "Licensing & Distribution", value: "licensing-distribution" },
      {
        label: "Digital Rights Management",
        value: "digital-rights-management",
      },
    ],
  },
  {
    label: "Personal Injury Law",
    value: "personal-injury-law",
    children: [
      { label: "Motor Vehicle Accidents", value: "motor-vehicle-accidents" },
      { label: "Slip and Fall", value: "slip-and-fall" },
      { label: "Product Liability", value: "product-liability" },
      { label: "Workplace Accidents", value: "workplace-accidents" },
      { label: "Premises Liability", value: "premises-liability" },
      {
        label: "Catastrophic & Brain Injuries",
        value: "catastrophic-brain-injuries",
      },
    ],
  },
  {
    label: "Medical Malpractice Law",
    value: "medical-malpractice-law",
    children: [
      {
        label: "Misdiagnosis & Delayed Diagnosis",
        value: "misdiagnosis-delayed-diagnosis",
      },
      { label: "Surgical Errors", value: "surgical-errors" },
      { label: "Birth Injuries", value: "birth-injuries" },
      { label: "Medication Errors", value: "medication-errors" },
      { label: "Nursing Home Negligence", value: "nursing-home-negligence" },
      { label: "Informed Consent Issues", value: "informed-consent-issues" },
    ],
  },
  {
    label: "Constitutional Law",
    value: "constitutional-law",
    children: [
      { label: "Free Speech & Expression", value: "free-speech-expression" },
      {
        label: "Due Process & Equal Protection",
        value: "due-process-equal-protection",
      },
      { label: "Religious Freedom", value: "religious-freedom" },
      { label: "Privacy Rights", value: "privacy-rights" },
      { label: "Voting Rights", value: "voting-rights" },
      { label: "Separation of Powers", value: "separation-of-powers" },
      { label: "Human Rights Law", value: "human-rights-law" },
    ],
  },
  {
    label: "Civil Rights",
    value: "civil-rights",
    children: [
      { label: "Anti-Discrimination Law", value: "anti-discrimination-law" },
      { label: "Refugee & Asylum Rights", value: "refugee-asylum-rights" },
      { label: "Indigenous Rights", value: "indigenous-rights" },
      { label: "Prisoner Rights", value: "prisoner-rights" },
      {
        label: "International Human Rights Treaties",
        value: "international-human-rights-treaties",
      },
    ],
  },
  {
    label: "Trust and Estate Law",
    value: "trust-estate-law",
    children: [
      { label: "Wills & Trusts", value: "wills-trusts" },
      {
        label: "Estate Planning & Administration",
        value: "estate-planning-administration",
      },
      { label: "Probate Litigation", value: "probate-litigation" },
      { label: "Inheritance Disputes", value: "inheritance-disputes" },
      { label: "Asset Protection", value: "asset-protection" },
      { label: "Charitable Trusts", value: "charitable-trusts" },
    ],
  },
  {
    label: "International Law",
    value: "international-law",
    children: [
      { label: "International Trade Law", value: "international-trade-law" },
      {
        label: "Diplomatic & Consular Law",
        value: "diplomatic-consular-law",
      },
      {
        label: "International Arbitration",
        value: "international-arbitration",
      },
      { label: "Humanitarian Law", value: "humanitarian-law" },
      {
        label: "International Criminal Law",
        value: "international-criminal-law",
      },
      { label: "Treaty & Convention Law", value: "treaty-convention-law" },
    ],
  },
  {
    label: "Antitrust Law",
    value: "antitrust-law",
    children: [
      {
        label: "Merger Review & Regulation",
        value: "merger-review-regulation",
      },
      { label: "Price Fixing & Collusion", value: "price-fixing-collusion" },
      { label: "Monopolistic Practices", value: "monopolistic-practices" },
      { label: "Cartel Activities", value: "cartel-activities" },
      {
        label: "Market Allocation Schemes",
        value: "market-allocation-schemes",
      },
      { label: "Abuse of Dominance", value: "abuse-dominance" },
    ],
  },
  {
    label: "Admiralty Law",
    value: "admiralty-law",
    children: [
      { label: "Maritime Commerce", value: "maritime-commerce" },
      {
        label: "Shipping & Cargo Disputes",
        value: "shipping-cargo-disputes",
      },
      { label: "Marine Insurance", value: "marine-insurance" },
      { label: "Salvage & Towage Rights", value: "salvage-towage-rights" },
      { label: "Cargo Claims", value: "cargo-claims" },
      {
        label: "Piracy & Maritime Security",
        value: "piracy-maritime-security",
      },
    ],
  },
  {
    label: "Health Law",
    value: "health-law",
    children: [
      {
        label: "Healthcare Regulation & Compliance",
        value: "healthcare-regulation-compliance",
      },
      {
        label: "Hospital & Patient Rights",
        value: "hospital-patient-rights",
      },
      { label: "Health Insurance Law", value: "health-insurance-law" },
      { label: "Public Health Law", value: "public-health-law" },
      {
        label: "Bioethics & Medical Research Law",
        value: "bioethics-medical-research-law",
      },
      { label: "FDA & Drug Regulation", value: "fda-drug-regulation" },
    ],
  },
];

export const topLanguagesUSA = [
  "English",
  "Spanish",
  "Chinese (Mandarin and Cantonese)",
  "Tagalog (including Filipino)",
  "Vietnamese",
  "French",
  "Arabic",
  "Korean",
  "Russian",
  "German",
  "Haitian Creole",
  "Portuguese",
  "Hindi",
  "Italian",
  "Polish",
  "Japanese",
  "Urdu",
  "Persian (Farsi and Dari)",
  "Gujarati",
  "Telugu",
];

export const flatRoleDict = {
  partner: "Partner",
  "senior-partner": "Senior Partner",
  "managing-partner": "Managing Partner",
  associate: "Associate",
  "senior-associate": "Senior Associate",
  "of-counsel": "Of Counsel",
  "general-counsel": "General Counsel",
  "chief-legal-officer": "Chief Legal Officer",
  "legal-director": "Legal Director",
  "legal-manager": "Legal Manager",
  "corporate-counsel": "Corporate Counsel",
  "trial-attorney": "Trial Attorney",
  "litigation-attorney": "Litigation Attorney",
  "real-estate-attorney": "Real Estate Attorney",
  "in-house-counsel": "In-House Counsel",
  "legal-intern": "Legal Intern",
};

export const flatDegreeDict = {
  "juris-doctor-jd": "Juris Doctor (JD)",
  "master-of-laws-llm": "Master of Laws (LL.M.)",
  "doctor-of-juridical-science-sjd": "Doctor of Juridical Science (SJD)",
  "bachelor-of-laws-llb": "Bachelor of Laws (LL.B.)",
  "master-of-legal-studies-mls": "Master of Legal Studies (MLS)",
  "master-of-dispute-resolution-mdr": "Master of Dispute Resolution (MDR)",
  "doctor-of-law-jsd": "Doctor of Law (JSD)",
  "doctor-of-comparative-law-dcl": "Doctor of Comparative Law (DCL)",
  "legal-practice-course-lpc": "Legal Practice Course (LPC)",
  "bar-professional-training-course-bptc":
    "Bar Professional Training Course (BPTC)",
  "paralegal-certificate": "Paralegal Certificate",
  "certified-legal-manager-clm": "Certified Legal Manager (CLM)",
  "certified-paralegal-cp": "Certified Paralegal (CP)",
  "certified-specialist-in-family-law": "Certified Specialist in Family Law",
  "certified-specialist-in-immigration-law":
    "Certified Specialist in Immigration Law",
  "certified-specialist-in-criminal-law":
    "Certified Specialist in Criminal Law",
  "certified-specialist-in-tax-law": "Certified Specialist in Tax Law",
  "certified-specialist-in-personal-injury":
    "Certified Specialist in Personal Injury",
  "certified-specialist-in-civil-litigation":
    "Certified Specialist in Civil Litigation",
  "master-of-science-in-law-msl": "Master of Science in Law (MSL)",
  "doctor-of-business-law-dbl": "Doctor of Business Law (DBL)",
};

export const flatSchoolDict = {
  "university-of-akron-school-of-law": "University of Akron School of Law",
  "university-of-alabama-school-of-law": "University of Alabama School of Law",
  "albany-law-school": "Albany Law School",
  "american-university-washington-college-of-law":
    "American University Washington College of Law",
  "appalachian-school-of-law": "Appalachian School of Law",
  "university-of-arizona-college-of-law":
    "University of Arizona James E. Rogers College of Law",
  "arizona-state-university-college-of-law":
    "Arizona State University Sandra Day O’Connor College of Law",
  "university-of-arkansas-school-of-law-fayetteville":
    "University of Arkansas School of Law - Fayetteville",
  "university-of-arkansas-little-rock-law-school":
    "University of Arkansas at Little Rock, William H. Bowen School of Law",
  "atlantas-john-marshall-law-school": "Atlanta's John Marshall Law School",
  "ave-maria-school-of-law": "Ave Maria School of Law",
  "university-of-baltimore-school-of-law":
    "University of Baltimore School of Law",
  "barry-university-school-of-law": "Barry University School of Law",
  "baylor-law-school": "Baylor Law School",
  "belmont-university-college-of-law": "Belmont University College of Law",
  "boston-college-law-school": "Boston College Law School",
  "boston-university-school-of-law": "Boston University School of Law",
  "brigham-young-university-law-school":
    "Brigham Young University J. Reuben Clark Law School",
  "brooklyn-law-school": "Brooklyn Law School",
  "university-at-buffalo-school-of-law": "University at Buffalo School of Law",
  "university-of-california-berkeley-school-of-law":
    "University of California, Berkeley School of Law",
  "university-of-california-davis-school-of-law":
    "University of California, Davis School of Law",
  "university-of-california-san-francisco-law-school":
    "University of California, San Francisco College of the Law",
  "university-of-california-irvine-school-of-law":
    "University of California, Irvine School of Law",
  "university-of-california-los-angeles-school-of-law":
    "University of California, Los Angeles School of Law",
  "california-western-school-of-law": "California Western School of Law",
  "campbell-university-school-of-law":
    "Campbell University Norman Adrian Wiggins School of Law",
  "capital-university-law-school": "Capital University Law School",
  "case-western-reserve-university-school-of-law":
    "Case Western Reserve University School of Law",
  "catholic-university-of-america-law-school":
    "The Catholic University of America Columbus School of Law",
  "chapman-university-school-of-law":
    "Chapman University Dale E. Fowler School of Law",
  "charleston-school-of-law": "Charleston School of Law",
  "university-of-chicago-law-school": "University of Chicago Law School",
  "chicago-kent-college-of-law":
    "Chicago-Kent College of Law at Illinois Institute of Technology",
  "university-of-cincinnati-college-of-law":
    "University of Cincinnati College of Law",
  "cuny-school-of-law": "City University of New York (CUNY) School of Law",
  "cleveland-state-university-college-of-law":
    "Cleveland State University College of Law",
  "university-of-colorado-law-school": "University of Colorado Law School",
  "columbia-law-school": "Columbia Law School",
  "university-of-connecticut-school-of-law":
    "University of Connecticut School of Law",
  "cooley-law-school":
    "Western Michigan University Thomas M. Cooley Law School",
  "cornell-law-school": "Cornell Law School",
  "creighton-university-school-of-law": "Creighton University School of Law",
  "university-of-dayton-school-of-law": "University of Dayton School of Law",
  "university-of-denver-law-school":
    "University of Denver Sturm College of Law",
  "depaul-university-college-of-law": "DePaul University College of Law",
  "university-of-detroit-mercy-school-of-law":
    "University of Detroit Mercy School of Law",
  "university-of-district-of-columbia-law-school":
    "University of the District of Columbia David A. Clarke School of Law",
  "drake-university-law-school": "Drake University Law School",
  "drexel-university-school-of-law":
    "Drexel University Thomas R. Kline School of Law",
  "duke-university-school-of-law": "Duke University School of Law",
  "duquesne-university-school-of-law": "Duquesne University School of Law",
  "elon-university-school-of-law": "Elon University School of Law",
  "emory-university-school-of-law": "Emory University School of Law",
  "faulkner-university-school-of-law":
    "Faulkner University Thomas Goode Jones School of Law",
  "university-of-florida-college-of-law":
    "University of Florida Levin College of Law",
  "florida-a-m-university-college-of-law":
    "Florida A&M University College of Law",
  "florida-international-university-college-of-law":
    "Florida International University College of Law",
  "florida-state-university-college-of-law":
    "Florida State University College of Law",
  "fordham-university-school-of-law": "Fordham University School of Law",
  "george-mason-university-law-school":
    "George Mason University Antonin Scalia Law School",
  "georgetown-university-law-center": "Georgetown University Law Center",
  "george-washington-university-law-school":
    "The George Washington University Law School",
  "university-of-georgia-school-of-law": "University of Georgia School of Law",
  "georgia-state-university-college-of-law":
    "Georgia State University College of Law",
  "golden-gate-university-school-of-law":
    "Golden Gate University School of Law",
  "gonzaga-university-school-of-law": "Gonzaga University School of Law",
  "harvard-law-school": "Harvard Law School",
  "university-of-hawaii-school-of-law":
    "University of Hawaii William S. Richardson School of Law",
  "hofstra-university-school-of-law": "Hofstra University School of Law",
  "south-texas-college-of-law-houston": "South Texas College of Law Houston",
  "howard-university-school-of-law": "Howard University School of Law",
  "university-of-idaho-college-of-law": "University of Idaho College of Law",
  "university-of-illinois-chicago-law-school":
    "University of Illinois Chicago School of Law",
  "university-of-illinois-college-of-law":
    "University of Illinois College of Law",
  "indiana-university-maurer-school-of-law":
    "Indiana University Maurer School of Law",
  "indiana-university-robert-h-mckinney-school-of-law":
    "Indiana University Robert H. McKinney School of Law",
  "inter-american-university-school-of-law":
    "Inter-American University of Puerto Rico School of Law",
  "university-of-iowa-college-of-law": "University of Iowa College of Law",
  "jacksonville-law-school": "Jacksonville Law School",
  "judge-advocate-generals-school": "Judge Advocate General's School",
  "university-of-kansas-school-of-law": "University of Kansas School of Law",
  "university-of-kentucky-college-of-law":
    "University of Kentucky College of Law",
  "liberty-university-school-of-law": "Liberty University School of Law",
  "lincoln-memorial-university-school-of-law":
    "Lincoln Memorial University Duncan School of Law",
  "lewis-and-clark-law-school": "Lewis & Clark Law School",
  "louisiana-state-university-law-center":
    "Louisiana State University Paul M. Hebert Law Center",
  "louisville-law-school": "Louisville Law School",
  "loyola-university-chicago-law-school":
    "Loyola University Chicago School of Law",
  "loyola-marymount-university-loyola-law-school":
    "Loyola Marymount University Loyola Law School",
  "loyola-university-new-orleans-college-of-law":
    "Loyola University New Orleans College of Law",
  "university-of-maine-school-of-law": "University of Maine School of Law",
  "marquette-university-law-school": "Marquette University Law School",
  "university-of-maryland-carey-school-of-law":
    "University of Maryland Carey School of Law",
  "university-of-massachusetts-school-of-law":
    "University of Massachusetts School of Law",
  "mcgeorge-school-of-law": "McGeorge School of Law, University of the Pacific",
  "university-of-memphis-cecil-c-humphreys-school-of-law":
    "University of Memphis Cecil C. Humphreys School of Law",
  "mercer-university-school-of-law": "Mercer University School of Law",
  "university-of-miami-school-of-law": "University of Miami School of Law",
  "michigan-state-university-college-of-law":
    "Michigan State University College of Law",
  "university-of-michigan-law-school": "University of Michigan Law School",
  "university-of-minnesota-law-school": "University of Minnesota Law School",
  "mississippi-college-school-of-law": "Mississippi College School of Law",
  "university-of-mississippi-school-of-law":
    "University of Mississippi School of Law",
  "university-of-missouri-school-of-law":
    "University of Missouri School of Law",
  "university-of-missouri-kansas-city-school-of-law":
    "University of Missouri-Kansas City School of Law",
  "mitchell-hamline-school-of-law": "Mitchell Hamline School of Law",
  "university-of-montana-school-of-law": "University of Montana School of Law",
  "university-of-nebraska-college-of-law":
    "University of Nebraska College of Law",
  "university-of-nevada-las-vegas-william-s-boyd-school-of-law":
    "University of Nevada, Las Vegas, William S. Boyd School of Law",
  "new-england-law-boston": "New England Law | Boston",
  "university-of-new-mexico-school-of-law":
    "University of New Mexico School of Law",
  "franklin-pierce-school-of-law": "Franklin Pierce School of Law",
  "new-york-law-school": "New York Law School",
  "new-york-university-school-of-law": "New York University School of Law",
  "university-of-north-carolina-school-of-law":
    "University of North Carolina School of Law",
  "north-carolina-central-university-school-of-law":
    "North Carolina Central University School of Law",
  "university-of-north-dakota-school-of-law":
    "University of North Dakota School of Law",
  "northeastern-university-school-of-law":
    "Northeastern University School of Law",
  "northern-illinois-university-college-of-law":
    "Northern Illinois University College of Law",
  "northern-kentucky-university-chase-college-of-law":
    "Northern Kentucky University Chase College of Law",
  "northwestern-university-pritzker-school-of-law":
    "Northwestern University Pritzker School of Law",
  "university-of-notre-dame-law-school": "University of Notre Dame Law School",
  "nova-southeastern-university-shepard-broad-college-of-law":
    "Nova Southeastern University Shepard Broad College of Law",
  "ohio-northern-university-pettit-college-of-law":
    "Ohio Northern University Pettit College of Law",
  "the-ohio-state-university-moritz-college-of-law":
    "The Ohio State University Moritz College of Law",
  "university-of-oklahoma-college-of-law":
    "University of Oklahoma College of Law",
  "oklahoma-city-university-school-of-law":
    "Oklahoma City University School of Law",
  "university-of-oregon-school-of-law": "University of Oregon School of Law",
  "pace-university-elisabeth-haub-school-of-law":
    "Pace University Elisabeth Haub School of Law",
  "university-of-pennsylvania-carey-law-school":
    "University of Pennsylvania Carey Law School",
  "penn-state-dickinson-law": "Penn State Dickinson Law",
  "pepperdine-university-caruso-school-of-law":
    "Pepperdine University Caruso School of Law",
  "university-of-pittsburgh-school-of-law":
    "University of Pittsburgh School of Law",
  "pontifical-catholic-university-of-puerto-rico-school-of-law":
    "Pontifical Catholic University of Puerto Rico School of Law",
  "university-of-puerto-rico-school-of-law":
    "University of Puerto Rico School of Law",
  "quinnipiac-university-school-of-law": "Quinnipiac University School of Law",
  "regent-university-school-of-law": "Regent University School of Law",
  "university-of-richmond-school-of-law":
    "University of Richmond School of Law",
  "roger-williams-university-school-of-law":
    "Roger Williams University School of Law",
  "rutgers-law-school": "Rutgers Law School",
  "st-johns-university-school-of-law": "St. John's University School of Law",
  "saint-louis-university-school-of-law":
    "Saint Louis University School of Law",
  "st-marys-university-school-of-law": "St. Mary's University School of Law",
  "university-of-st-thomas-school-of-law-florida":
    "University of St. Thomas School of Law (Florida)",
  "university-of-st-thomas-school-of-law-minnesota":
    "University of St. Thomas School of Law (Minnesota)",
  "samford-university-cumberland-school-of-law":
    "Samford University Cumberland School of Law",
  "university-of-san-diego-school-of-law":
    "University of San Diego School of Law",
  "university-of-san-francisco-school-of-law":
    "University of San Francisco School of Law",
  "santa-clara-university-school-of-law":
    "Santa Clara University School of Law",
  "seattle-university-school-of-law": "Seattle University School of Law",
  "seton-hall-university-school-of-law": "Seton Hall University School of Law",
  "university-of-south-carolina-school-of-law":
    "University of South Carolina School of Law",
  "university-of-south-dakota-school-of-law":
    "University of South Dakota School of Law",
  "south-texas-college-of-law-houston": "South Texas College of Law Houston",
  "southern-university-law-center": "Southern University Law Center",
  "university-of-southern-california-gould-school-of-law":
    "University of Southern California Gould School of Law",
  "southern-illinois-university-school-of-law":
    "Southern Illinois University School of Law",
  "southern-methodist-university-dedman-school-of-law":
    "Southern Methodist University Dedman School of Law",
  "southwestern-law-school": "Southwestern Law School",
  "stanford-law-school": "Stanford Law School",
  "stetson-university-college-of-law": "Stetson University College of Law",
  "suffolk-university-law-school": "Suffolk University Law School",
  "syracuse-university-college-of-law": "Syracuse University College of Law",
  "temple-university-beasley-school-of-law":
    "Temple University Beasley School of Law",
  "university-of-tennessee-college-of-law":
    "The University of Tennessee College of Law",
  "university-of-texas-school-of-law": "The University of Texas School of Law",
  "texas-am-university-school-of-law": "Texas A&M University School of Law",
  "texas-southern-university-thurgood-marshall-school-of-law":
    "Texas Southern University Thurgood Marshall School of Law",
  "texas-tech-university-school-of-law": "Texas Tech University School of Law",
  "university-of-toledo-college-of-law":
    "The University of Toledo College of Law",
  "touro-college-jacob-d-fuchsberg-law-center":
    "Touro College Jacob D. Fuchsberg Law Center",
  "tulane-university-law-school": "Tulane University Law School",
  "university-of-tulsa-college-of-law": "University of Tulsa College of Law",
  "university-of-north-texas-dallas-college-of-law":
    "University of North Texas Dallas College of Law",
  "university-of-utah-s-j-quinney-college-of-law":
    "University of Utah S.J. Quinney College of Law",
  "vanderbilt-university-law-school": "Vanderbilt University Law School",
  "vermont-law-school": "Vermont Law School",
  "villanova-university-charles-widger-school-of-law":
    "Villanova University Charles Widger School of Law",
  "university-of-virginia-school-of-law":
    "University of Virginia School of Law",
  "wake-forest-university-school-of-law":
    "Wake Forest University School of Law",
  "washburn-university-school-of-law": "Washburn University School of Law",
  "washington-and-lee-university-school-of-law":
    "Washington and Lee University School of Law",
  "george-washington-university-law-school":
    "The George Washington University Law School",
  "washington-university-in-st-louis-school-of-law":
    "Washington University in St. Louis School of Law",
  "wayne-state-university-law-school": "Wayne State University Law School",
  "western-new-england-university-school-of-law":
    "Western New England University School of Law",
  "western-state-college-of-law":
    "Western State College of Law at Argosy University",
  "west-virginia-university-college-of-law":
    "West Virginia University College of Law",
  "widener-university-delaware-law-school":
    "Widener University Delaware Law School",
  "widener-university-commonwealth-law-school":
    "Widener University Commonwealth Law School",
  "willamette-university-college-of-law":
    "Willamette University College of Law",
  "college-of-william-and-mary-law-school":
    "College of William & Mary Law School",
  "wilmington-university-college-of-law":
    "Wilmington University College of Law",
  "university-of-wisconsin-law-school": "University of Wisconsin Law School",
  "university-of-wyoming-college-of-law":
    "University of Wyoming College of Law",
  "yale-law-school": "Yale Law School",
  "yeshiva-university-cardozo-school-of-law":
    "Yeshiva University Benjamin N. Cardozo School of Law",
};

export const flatProfessionalMembershipsDict = {
  "american-bar-association": "American Bar Association",
  "national-bar-association": "National Bar Association",
  "hispanic-national-bar-association": "Hispanic National Bar Association",
  "national-asian-pacific-american-bar-association":
    "National Asian Pacific American Bar Association",
  "national-native-american-bar-association":
    "National Native American Bar Association",
  "american-association-for-justice": "American Association for Justice",
  "national-association-of-criminal-defense-lawyers":
    "National Association of Criminal Defense Lawyers",
  "american-immigration-lawyers-association":
    "American Immigration Lawyers Association",
  "national-association-of-women-lawyers":
    "National Association of Women Lawyers",
  "national-association-of-women-judges":
    "National Association of Women Judges",
  "association-of-corporate-counsel": "Association of Corporate Counsel",
  "american-intellectual-property-law-association":
    "American Intellectual Property Law Association",
  "association-of-life-insurance-counsel":
    "Association of Life Insurance Counsel",
  "maritime-law-association-of-the-united-states":
    "Maritime Law Association of the United States",
  "energy-bar-association": "Energy Bar Association",
  "american-law-institute": "American Law Institute",
  "federal-bar-association": "Federal Bar Association",
  "federal-circuit-bar-association": "Federal Circuit Bar Association",
  "federal-communications-bar-association":
    "Federal Communications Bar Association",
  "judge-advocates-association": "Judge Advocates Association",
  "american-arbitration-association": "American Arbitration Association",
  "defense-research-institute": "Defense Research Institute",
  "federation-of-defense-and-corporate-counsel":
    "Federation of Defense and Corporate Counsel",
  "association-of-american-law-schools": "Association of American Law Schools",
  "american-academy-of-matrimonial-lawyers":
    "American Academy of Matrimonial Lawyers",
  "american-academy-of-forensic-sciences":
    "American Academy of Forensic Sciences",
  "national-association-of-attorneys-general":
    "National Association of Attorneys General",
  "association-of-prosecuting-attorneys":
    "Association of Prosecuting Attorneys",
  "national-board-of-trial-advocacy": "National Board of Trial Advocacy",
  "national-association-of-muslim-lawyers":
    "National Association of Muslim Lawyers",
};

export function getPracticeAreaLabel(key) {
  return flatPracticeAreaDict[key] || "";
}

export function getRoleLabel(key) {
  return flatRoleDict[key] || "";
}

export function getDegreeDict(key) {
  return flatDegreeDict[key] || "";
}

export function getSchoolKey(key) {
  return flatSchoolDict[key] || "";
}

export function getMembership(key) {
  return flatProfessionalMembershipsDict[key] || "";
}

/**
 * Checks if the current time is within the allowed join window for a meeting.
 * @param {string} startISO - ISO string for meeting start (UTC)
 * @param {string} endISO - ISO string for meeting end (UTC)
 * @returns {{ allowed: boolean, countdown: number, start: Date, end: Date }}
 */
export function canJoinMeetingNow(startISO, endISO) {
  const now = new Date();
  const start = new Date(startISO);
  const end = new Date(endISO);
  const allowed = now >= start && now <= end;
  const countdown = start - now; // ms until allowed
  return { allowed, countdown, start, end };
}

/**
 * Formats a meeting window in the user's local time zone.
 * @param {Date} start
 * @param {Date} end
 * @returns {string}
 */
export function formatMeetingWindowLocal(start, end) {
  const optsDate = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  const optsTime = { hour: '2-digit', minute: '2-digit' };
  const startDate = start.toLocaleDateString(undefined, optsDate);
  const startTime = start.toLocaleTimeString(undefined, optsTime);
  const endTime = end.toLocaleTimeString(undefined, optsTime);
  return `${startDate}, ${startTime} - ${endTime}`;
}

/**
 * Formats countdown in days, hours, and minutes format
 * @param {number} countdownMs - Countdown in milliseconds
 * @returns {string}
 */
export function formatCountdown(countdownMs) {
  if (countdownMs <= 0) return "Starting Now";
  
  const days = Math.floor(countdownMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((countdownMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((countdownMs % (1000 * 60 * 60)) / (1000 * 60));
  
  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  
  return parts.join(' ') || "Less than 1m";
}

/**
 * Gets the user's timezone name
 * @returns {string}
 */
export function getUserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Formats meeting details with timezone information
 * @param {Date} start
 * @param {Date} end
 * @returns {object}
 */
export function formatMeetingDetails(start, end) {
  const optsDate = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const optsTime = { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' };
  
  const startDate = start.toLocaleDateString(undefined, optsDate);
  const startTime = start.toLocaleTimeString(undefined, optsTime);
  const endTime = end.toLocaleTimeString(undefined, optsTime);
  const timezone = getUserTimezone();
  
  return {
    date: startDate,
    startTime,
    endTime,
    timezone,
    fullText: `${startDate}, ${startTime} - ${endTime} (${timezone})`
  };
}
